import { FunctionComponent } from "react";

import { classNames } from "@/utils/classNames";

export enum SettingScope {
	WORKSPACE = "WORKSPACE",
	PER_LIST = "PER_LIST",
}

interface ScopeBadgeProps {
	label: string;
	scope?: SettingScope;
}

/**
 * The scope chip on a Contacts & Enrichment card (PREC-4261): "Workspace-wide" for a setting that
 * is the same for every list, "Overridable per list" for one a list can override in its settings.
 */
export const ScopeBadge: FunctionComponent<ScopeBadgeProps> = ({
	label,
	scope = SettingScope.WORKSPACE,
}) => (
	<span
		className={classNames(
			"inline-flex items-center rounded px-1.5 py-0.5 text-xs font-medium",
			scope === SettingScope.PER_LIST
				? "bg-light-blue text-blue-action"
				: "bg-background-light text-text-meta"
		)}
		data-scope={scope}
		data-testid="contact-settings-scope-badge"
	>
		{label}
	</span>
);
